



































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class Modal extends Vue {
  @Prop()
  showModal!: boolean;

  @Prop()
  width!: string;

  @Prop({ default: 'none' })
  minWidth!: string;

  @Prop()
  title!: string;

  @Prop()
  description!: string;

  @Prop({ default: '' })
  redTitle!: string;

  @Prop({ default: '' })
  extraClasses!: string;

  closeClicked() {
    this.$emit('closeModal');
  }

  mounted() {
    if (this.showModal) {
      this.toggleBodyScrolling(false);
      this.addEscapeButtonListener();
    }
  }

  @Watch('showModal')
  isOpenChange() {
    if (this.showModal) {
      this.toggleBodyScrolling(false);
      this.addEscapeButtonListener();
    } else {
      this.toggleBodyScrolling(true);
      this.removeEscapeButtonListener();
    }
  }

  escapeButtonEvent = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.$emit('closeModal');
    }
  };

  addEscapeButtonListener() {
    document.addEventListener('keydown', this.escapeButtonEvent);
  }

  removeEscapeButtonListener() {
    document.removeEventListener('keydown', this.escapeButtonEvent);
  }

  toggleBodyScrolling(isScrolling: boolean) {
    const bodyElement = document.querySelector('body');

    if (bodyElement) {
      if (isScrolling) {
        bodyElement.style.overflow = 'auto';
      } else {
        bodyElement.style.overflow = 'hidden';
      }
    }
  }
}
